import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { UsuarioTO } from "../../schema/User/UsuarioTO";

@Injectable({
    providedIn: "root"
})
export class ApiInviteService {
    constructor(private http: HttpClient) {}

    public verificarInvite(subscriptionId: string, token: string): Observable<UsuarioTO> {
        const params = new HttpParams().set("subscriptionId", subscriptionId);

        return this.http.get<UsuarioTO>(`${environment.identity.url}/api/v1/invite/${token}`, { params: params });
    }
}
